// Copyright (c) 2019 Comsearch, Inc., All rights reserved

export const LOSS_CANNOT_BE_LESS_THAN_0 = 'Cannot be less than 0(dB).'
export const LOSS_CANNOT_BE_GREATER_THAN_999 = 'Cannot be greater than 999.9(dB).'
